<div class="modal-comp" *ngIf="object.modalContent !== undefined">
    <li class="{{clickable}}" [innerHTML]='object.modalContent' (click)='showDialog()' *ngIf='show'></li>
 </div>
 